import { PricesActions } from '../actions/prices.actions';
import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import { Action } from '@ngrx/store';
import { OrderRMXUL } from '@cemex-core/cmx-api';
import OrderScheduleActions from '../actions/schedule-order-confirmation.actions';

interface ExpirationTimer {
  minutes: number;
  seconds: number;
}

export interface State {
  orderItemsRMS?: OrderRMXUL[];
  orderTax?: string;
  orderNetValue?: string;
  dcoOverdueTimer?: ExpirationTimer;
}

const initialState: State = {
  orderItemsRMS: undefined,
  orderTax: undefined,
  orderNetValue: undefined,
  dcoOverdueTimer: { minutes: 0, seconds: 0 },
};

export const pricesReducer = createReducer(
  initialState,

  on(OrderScheduleActions.onlyCreateOrderSuccess, (state, { payload }) => {
    return {
      ...state,
      orderItemsRMS: payload.orderItemsRMS,
      orderNetValue: payload.orderNetValue,
      orderTax: payload.orderTax,
    };
  }),

  on(PricesActions.resetPrices, (state) => {
    return {
      ...state,
      orderItemsRMS: undefined,
      orderNetValue: undefined,
      orderTax: undefined,
      dcoOverdueTimer: { minutes: 9999, seconds: 0 },
    };
  }),

  on(PricesActions.setDcoOverdueTimer, (state, { minutes, seconds }) => {
    return {
      ...state,
      dcoOverdueTimer: { minutes, seconds },
    };
  }),
);

export function reducer(state: State | undefined, action: Action) {
  return pricesReducer(state, action);
}
